import React from 'react';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import SimulationOfferGroupProtectionForm from './SimulationOfferGroupProtectionForm.jsx';

const SimulationOfferGroupProtection = ({ getMiddleText }) => (
  <SimulationOfferGroupProtectionForm getMiddleText={getMiddleText} />
);

export default withMiddleFeatures(SimulationOfferGroupProtection);
